require('./bootstrap');

require('./jquery-3.5.1.min.js');


$(document).ready(function () {
  $('.toggle').click(function () {
    $('#nav').toggleClass('open');
    $('body').toggleClass('menu-open');
  });
});

$(document).ready(function () {
  $('.news-related-slider__related-slider').owlCarousel({
    loop: false,
    dots: true,
    nav: true,
    navText: ["<img src='/img/left-arr.svg'>", "<img src='/img/right-arr.svg'>"],
    margin: 10,

    responsive: {
      0: {
        items: 1,
        nav: false

      },
      460: {
        items: 2,
        nav: false
      },
      992: {
        items: 3
      }
    }
  })
});

$('.js-anchor-link').click(function (e) {
  e.preventDefault();
  var target = $($(this).attr('href'));
  if (target.length) {
    var scrollTo = target.offset().top;
    $('body, html').animate({scrollTop: scrollTo - 25 + 'px'}, 800);
  }
});

// $(document).ready(function(){
//     $(window).on('click', function(e){
//         if(e.target.className !== 'wrapper-main-search' ){
//             console.log('Close');
//             $('#resultSearchMain').css('display', 'none');
//         }
//     });
// });


// Search ajax
$('#mainSearch').on('keyup', function () {
  var text = $('#mainSearch').val();
  let url = $(this).closest('form').attr('action');
  // console.log(url);
  $.ajax({
    type: "GET",
    url: url,
    data: {text},
    success: function (response) {
      // response = JSON.parse(response);
      // console.log(response);

      if (response.count == 0) {
        var link = "<li><a href='#' class='btn disabled link-search'>Не найдено</a></li>";
        $('#resultSearchMain').html(link);
      } else {
        $('#resultSearchMain').html('');
        for (var article of response.articles) {
          var link = "<li><a href='" + article.link + "' class='btn link-search'>" + article.title + "</a></li>";
          $('#resultSearchMain').append(link);
        }
      }
      if ($('#mainSearch').val() == '') {
        $('#resultSearchMain').html('');
      }

      $(window).on('click', function (e) {
        if (e.target.className !== 'search-variations' || e.target.className !== 'main-menu__top-nav__search-form') {
          // console.log('Close', e.target.className);
          // console.log('Close', e.currentTarget);
          $('#resultSearchMain').html('');
        }
      });
    }
  });
});

document.querySelectorAll('.show-popup').forEach(button => {
  button.addEventListener('click', function () {
    let popupId = button.dataset.popupId;
    let popup = document.getElementById(popupId);

    showPopup(popup);
  });
});

function showPopup(popup) {
  const nav = document.getElementById('nav');

  if (nav.classList.contains('open') && document.body.classList.contains('menu-open')) {
    nav.classList.remove('open');
    document.body.classList.remove('menu-open');
  }

  document.querySelectorAll('.popup__wrapper').forEach(item => popup !== item ? closePopup(item) : null);

  if (popup && !popup.classList.contains('disabled')) {
    popup.classList.add('disabled');
    popup.style.display = 'flex';
    setTimeout(function () {
      popup.classList.add('active');
      document.body.classList.add("no-scroll");
    }, 15);
    setTimeout(function () {
      popup.classList.remove('disabled');
    }, 300);
  }
}

function closePopup(popup) {
  popup.classList.add('disabled');
  popup.classList.remove('active');
  document.body.classList.remove("no-scroll");
  setTimeout(function () {
    popup.style.display = 'none';
    popup.classList.remove('disabled');
  }, 300);
}

document.querySelectorAll('.popup__close').forEach(button => {
  button.addEventListener('click', function () {
    let popup = button.parentElement.parentElement;

    if (popup) {
      closePopup(popup);
    }
  });
});

document.querySelectorAll('.popup__wrapper').forEach(wrapper => {
  wrapper.addEventListener('click', function () {
    if (!wrapper.classList.contains('disabled')) {
      closePopup(wrapper);
    }
  });
});

document.querySelectorAll('.popup').forEach(popup => {
  popup.addEventListener('click', e => {
    e.stopPropagation();
  });
});


if (document.querySelector(".send-form")) {
  document.querySelectorAll(".send-form").forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      let form = element.closest('form');
      setTimeout(() => {
        let action = form.getAttribute('action');
        let method = form.getAttribute('method');
        let data = new FormData(form);

        (async () => {
          const rawResponse = await fetch(action, {
            method: method,
            headers: {
              'Accept': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            },
            body: data
          });
          const request = await rawResponse.json();

          if (request.status === true) {
            window.location.href = request.url;
          }

          if (request.status === false) {
            alert(request.message);
          }

          const errors = request.errors;

          if (errors) {
            const formItems = form.querySelectorAll("label.popup__form-item");

            formItems.forEach(item => {
              const itemError = item.querySelector(".popup__form-error");
              const key = item.getAttribute("for");

              if (errors.hasOwnProperty(key)) {
                if (!itemError) {
                  const span = document.createElement('span');

                  span.setAttribute('class', 'popup__form-error');
                  span.textContent = errors[key] + "";
                  item.appendChild(span);
                } else {
                  itemError.textContent = errors[key];
                }
              } else {
                if (itemError) {
                  itemError.remove()
                }
              }
            });
          }
        })();
      }, 200)
    });
  });
}

if (document.querySelector("#check-status")) {
  document.getElementById('check-status').addEventListener('click', (e) => {
    e.preventDefault();
    let element = document.getElementById('check-status');
    element.classList.add('loader');
    setTimeout(function () {
      (async () => {
        const rawResponse = await fetch('client-status', {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: {}
        });
        const request = await rawResponse.json();

        if (request.status === true) {
          let checkStatus = document.getElementById('check-status__status');
          checkStatus.innerHTML = '';
          let strong = document.createElement('strong');
          strong.append(request.client_status);
          checkStatus.append(strong);


        }
      })();
      element.classList.remove('loader');
    }, 2000);
  });
}
